import user from "./userReducer";
import theme from "./theme";
import common from "./common";
import reportsData from "./reportsData";
import viewReportData from "./viewReportData";
import operationTypeData from "./operationTypeData";

export default {
  user,
  theme,
  common,
  reportsData,
  viewReportData,
  operationTypeData,
};
